import styled from "@emotion/styled";
import { mq } from "@styles/helpers";
import { Devices } from "@styles/tokens";

export const Container = styled.div`
    background:#fff;
    padding:14px;
    border-radius: 10px;
    box-shadow: 0 1px 4px 2px rgba(0,0,0,0.1);
    position: relative;

     ${mq(Devices.laptop)}{
        grid-column: auto / span 2;
        aspect-ratio: 1 / 1.3;
    }
`;

export const TopTitle = styled.div`
    font-size: 18px;
    font-weight: 500;
    display:flex;
    align-items: center;
    color:#FB4856;
    padding:0 10px;
`;

export const CalNav = styled.div`
    display:flex;
    align-items: center;
    justify-content: space-between;
    margin: 10px 0 6% 0;
`;

export const NavBtn = styled.div`
    padding:12px;
    display:flex;
    border-radius: 50%;

    > svg{
        height:14px;
        width:14px;
        path{

        }
    }

    :nth-of-type(1){
        transform: rotate(90deg);
    }

    :nth-of-type(3){
        transform: rotate(270deg);
    }
`;

export const NavTitle = styled.div`
    font-size: 18px;
`;

export const CalDays = styled.div`
    
`;

export const DayHeader = styled.div`
    display:grid;
    grid-template-columns: repeat(7, 1fr);
    padding-bottom: 10px;

    span{
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: 500;
    }
`;

export const DayContainer = styled.div`
    display:grid;
    grid-template-columns: repeat(7, 1fr);
`;

export const Day = styled.div<{active?:number}>`
    display: flex;
    align-items: center;
    justify-content: center;
    aspect-ratio: 1 / 1;
    font-size: 14px;
    padding:8%;

    span{
        font-size: clamp(10px, 1vw, 18px);
        width:100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: ${props => props.active === 1?"#2A848E":props.active === 2?"rgb(250, 80, 94)":props.active === 3?"rgb(254, 212, 37)":props.active === 4?"rgb(253, 147, 79)":"transparent"};
        color:${props => props.active != 0?"#fff":"#666666"};
        border-radius: 50%;
        aspect-ratio: 1 / 1;
        opacity: 0.9;
        cursor: ${props => props.active?"pointer":"unset"};

        :hover{
            opacity: 1;
        }
    }

    ${mq(Devices.laptop)}{
        span{
            font-size: clamp(10px, 3vw, 18px);
        }
    }

    ${mq(Devices.mobile)}{
        span{
            font-size: clamp(10px, 4vw, 18px);
        }
    }
`;